import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const lotColors = {
    received: {
        bg: 'rgba(59,130,246,0.12)',
        color: '#60a5fa',
        border: 'rgba(59,130,246,0.3)',
        dot: '#3b82f6',
        pulse: true,
    },
    in_qc: {
        bg: 'rgba(245,158,11,0.12)',
        color: '#fbbf24',
        border: 'rgba(245,158,11,0.3)',
        dot: '#f59e0b',
        pulse: true,
    },
    released: {
        bg: 'rgba(0,212,170,0.12)',
        color: '#00d4aa',
        border: 'rgba(0,212,170,0.3)',
        dot: '#00d4aa',
        pulse: false,
    },
    quarantined: {
        bg: 'rgba(255,107,107,0.12)',
        color: '#ff6b6b',
        border: 'rgba(255,107,107,0.3)',
        dot: '#ff6b6b',
        pulse: false,
    },
    in_use: {
        bg: 'rgba(139,92,246,0.12)',
        color: '#a78bfa',
        border: 'rgba(139,92,246,0.3)',
        dot: '#8b5cf6',
        pulse: false,
    },
    depleted: {
        bg: 'rgba(107,114,128,0.10)',
        color: '#9ca3af',
        border: 'rgba(107,114,128,0.25)',
        dot: '#6b7280',
        pulse: false,
    },
    retired: {
        bg: 'rgba(107,114,128,0.08)',
        color: '#6b7280',
        border: 'rgba(107,114,128,0.20)',
        dot: '#6b7280',
        pulse: false,
    },
};
const qcColors = {
    pass: {
        bg: 'rgba(0,212,170,0.12)',
        color: '#00d4aa',
        border: 'rgba(0,212,170,0.3)',
        pulse: false,
    },
    warning: {
        bg: 'rgba(245,158,11,0.12)',
        color: '#fbbf24',
        border: 'rgba(245,158,11,0.3)',
        pulse: false,
    },
    fail: {
        bg: 'rgba(255,107,107,0.12)',
        color: '#ff6b6b',
        border: 'rgba(255,107,107,0.3)',
        pulse: false,
    },
    pending: {
        bg: 'rgba(107,114,128,0.10)',
        color: '#9ca3af',
        border: 'rgba(107,114,128,0.25)',
        pulse: true,
    },
};
const riskColors = {
    low: {
        bg: 'rgba(0,212,170,0.12)',
        color: '#00d4aa',
        border: 'rgba(0,212,170,0.3)',
        pulse: false,
    },
    medium: {
        bg: 'rgba(245,158,11,0.12)',
        color: '#fbbf24',
        border: 'rgba(245,158,11,0.3)',
        pulse: false,
    },
    high: {
        bg: 'rgba(255,107,107,0.12)',
        color: '#ff6b6b',
        border: 'rgba(255,107,107,0.3)',
        pulse: false,
    },
};
const sizeStyles = {
    sm: { fontSize: '10px', padding: '0 7px', height: '18px', dotSize: '5px' },
    md: { fontSize: '12px', padding: '0 10px', height: '22px', dotSize: '6px' },
    lg: { fontSize: '13px', padding: '0 14px', height: '28px', dotSize: '7px' },
};
const lotLabels = {
    received: 'Received',
    in_qc: 'In QC',
    released: 'Released',
    quarantined: 'Quarantined',
    in_use: 'In Use',
    depleted: 'Depleted',
    retired: 'Retired',
};
const qcLabels = {
    pass: 'Pass',
    warning: 'Warning',
    fail: 'Fail',
    pending: 'Pending',
};
const riskLabels = {
    low: 'Low Risk',
    medium: 'Medium Risk',
    high: 'High Risk',
};
export function StatusBadge({ variant = 'lot', lotStatus, qcResult, riskLevel, label, size = 'md', showDot, className, style, }) {
    let colors;
    let displayLabel;
    if (variant === 'lot' && lotStatus) {
        colors = lotColors[lotStatus];
        displayLabel = label ?? lotLabels[lotStatus];
    }
    else if (variant === 'qc' && qcResult) {
        colors = qcColors[qcResult];
        displayLabel = label ?? qcLabels[qcResult];
    }
    else if (variant === 'risk' && riskLevel) {
        colors = riskColors[riskLevel];
        displayLabel = label ?? riskLabels[riskLevel];
    }
    else {
        colors = { bg: 'rgba(107,114,128,0.10)', color: '#9ca3af', border: 'rgba(107,114,128,0.25)' };
        displayLabel = label ?? 'Unknown';
    }
    const { fontSize, padding, height, dotSize } = sizeStyles[size];
    const shouldPulse = showDot !== undefined ? showDot : colors.pulse;
    const hasDot = shouldPulse !== undefined ? shouldPulse : false;
    return (_jsxs("span", { className: className, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            padding,
            height,
            borderRadius: '9999px',
            fontSize,
            fontWeight: 500,
            fontFamily: 'var(--font-body, Inter, system-ui, sans-serif)',
            letterSpacing: '0.01em',
            background: colors.bg,
            color: colors.color,
            border: `1px solid ${colors.border}`,
            whiteSpace: 'nowrap',
            lineHeight: 1,
            ...style,
        }, children: [hasDot && (_jsx("span", { "aria-hidden": "true", style: {
                    width: dotSize,
                    height: dotSize,
                    borderRadius: '50%',
                    background: colors.dot ?? colors.color,
                    flexShrink: 0,
                    animation: 'status-dot-pulse 2s ease-in-out infinite',
                } })), displayLabel] }));
}
//# sourceMappingURL=StatusBadge.js.map